const api = [
  {
    name: 'wait',
    desc: '获取待审核列表',
    method: 'GET',
    path: 'getAuthenOrgBizs'
  },
  {
    name: 'done',
    desc: '获取已审核列表',
    method: 'GET',
    path: 'getHadAuthenOrgBizs'
  },
  {
    name: 'detail',
    desc: '获取业务详情',
    method: 'GET',
    path: 'getAuthenDetail'
  },
  {
    name: 'pass',
    desc: '审核通过',
    method: 'POST',
    path: 'pass'
  },
  {
    name: 'noPass',
    desc: '审核不通过',
    method: 'POST',
    path: 'noPass'
  }
]

export default {
  BASE_URL: '/sysOrgBiz',
  NAMESPACE: 'jc_tong',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/member/jc_tong.js